import { useQuery } from '@tanstack/react-query';

import { fetchUser } from '../services/api/users';

export const useUser = (userId?: string) => {
  return useQuery({
    queryKey: ['user', userId],
    queryFn: () => fetchUser(userId!),
    enabled: Boolean(userId),
  });
};
